import { useQuery } from 'react-query';
import { client } from 'src/utils/api-client';
import { useEsgOrganization, useLanguage } from 'src/common/hooks';

// eslint-disable-next-line import/prefer-default-export
export const getIndicatorsData = (period: string, id: string) => {
  const organization = useEsgOrganization();
  const { language } = useLanguage();

  const { data, isLoading, isError } = useQuery(
    ['indicators', organization.id, period, language],
    () => {
      return client.get(`/web/esg_v2/${organization.id}/${id}/indicators`);
    }
  );
  return {
    data,
    isLoading,
    isError,
  };
};
